<div class="row" >
	<div class="col-12" style="height: 200px;">
		<div *ngIf="product$ | async as product" class="kt-portlet kt-portlet--height-fluid">
			
			<div class="kt-portlet__body" >
				<div class="kt-widget kt-widget--user-profile-3">
					<div class="kt-widget__top">
						<div class="kt-widget__media kt-hidden-">
							<a href="javascript:void(0);">
								<!-- <img src="../../../../../../assets/media/products/product19.jpg"> -->
								<kt-product-photo [ProductCode]="product.kod" [Style]="'width:400px;'"></kt-product-photo>
							</a>
						</div>
						<!--<div class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
							P&G
						</div>-->

						<div class="kt-widget__content pt-0">
							<div class="kt-widget__head">

								<span class="kt-widget__username">
									{{product.name}}
									<i class="flaticon2-correct"></i>
								</span>

								<button type="button" class="close right" aria-label="Close" mat-dialog-close >
									<span aria-hidden="true">&times;</span>
								</button>

							</div>
							<div class="kt-widget__subhead pt-0">
								<p class="mb-1">
									#{{product.kod}}
								</p>
								<p class="mb-1">
									<span class="kt-badge kt-badge--success kt-badge--inline">{{product.businessUnitName}}</span>
									<span class="kt-badge kt-badge--unified-success kt-badge--inline kt-badge--bold">
										{{product.marka}}
									</span>
									<!-- <span *ngIf="(products$ | async).wmsTip != null" class="kt-badge kt-badge--unified-success kt-badge--inline kt-badge--bold">{{(products$ | async).wmsTip ?  'Hasan' : 'Sen'}}</span> -->

								</p>
								<p class="mb-1">
									<span class="kt-badge kt-badge--dark kt-badge--inline">
										{{product.type1Name}}
									</span>
									<span class="kt-badge kt-badge--unified-dark kt-badge--inline kt-badge--bold">
										{{product.type2Name}}
									</span>
									<span class="kt-badge kt-badge--unified-dark kt-badge--inline kt-badge--bold">
										{{product.type3Name}}
									</span>
									<span class="kt-badge kt-badge--unified-dark kt-badge--inline kt-badge--bold">
										{{product.type4Name}}
									</span>
								</p>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<hr />
	<div class="col-12">
		<div class="kt-portlet kt-portlet--height-fluid h-100">
			<div class="kt-portlet__head">
				<div class="kt-portlet__head-label">
					<h3 class="kt-portlet__head-title">
						{{tabTitle |async}}
					</h3>
				</div>
				<div class="kt-portlet__head-toolbar">
					<ul class="nav nav-pills nav-pills-sm nav-pills-label nav-pills-bold" role="tablist">
						<li class="nav-item" (click)="changeTab(TAB1)">
							<a href="javascript:;" [ngClass]="(numberTabByUsers | async) == TAB1 ? 'nav-link active': 'nav-link'"  data-toggle="tab"  role="tab">
								Ürün Ölçüleri
							</a>
						</li>
						<li class="nav-item" (click)="changeTab(TAB2)">
							<a href="javascript:;" [ngClass]="(numberTabByUsers | async) == TAB2 ? 'nav-link active': 'nav-link'"  data-toggle="tab"  role="tab">
								Stok Bilgisi
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="kt-portlet__body">
				<div class="tab-content">
					<div *ngIf="product$ | async as product" [ngClass]="(numberTabByUsers | async) == TAB1 ? 'tab-pane active': 'tab-pane'" [attr.id]="TAB1" aria-expanded="false">
						<div class="kt-widget5">
							<div class="kt-widget5__item">
								<div class="kt-widget5__content">
									<div class="kt-widget5__section">
										<span class="kt-widget5__title">
											Genişlik
										</span>
									</div>
								</div>
								<div class="kt-widget5__content">
									<div class="kt-widget5__stats">
										<span class="kt-widget5__number">{{product.width}} <small>cm</small></span>
									</div>
								</div>
							</div>
							<div class="kt-widget5__item">
								<div class="kt-widget5__content">
									<div class="kt-widget5__section">
										<span class="kt-widget5__title">
											Boy
										</span>
									</div>
								</div>
								<div class="kt-widget5__content">
									<div class="kt-widget5__stats">
										<span class="kt-widget5__number">{{product.height}} <small>cm</small></span>
									</div>
								</div>
							</div>
							<div class="kt-widget5__item">
								<div class="kt-widget5__content">
									<div class="kt-widget5__section">
										<span class="kt-widget5__title">
											Derinlik
										</span>
									</div>
								</div>
								<div class="kt-widget5__content">
									<div class="kt-widget5__stats">
										<span class="kt-widget5__number">{{product.depth}} <small>cm</small></span>
									</div>
								</div>
							</div>
							<div class="kt-widget5__item">
								<div class="kt-widget5__content">
									<div class="kt-widget5__section">
										<span class="kt-widget5__title">
											Ağırlık
										</span>
									</div>
								</div>
								<div class="kt-widget5__content">
									<div class="kt-widget5__stats">
										<span class="kt-widget5__number">{{product.weight}} <small>gr</small></span>
									</div>
								</div>
							</div>
							<div class="kt-widget5__item">
								<div class="kt-widget5__content">
									<div class="kt-widget5__section">
										<span class="kt-widget5__title">
											Desi
										</span>
									</div>
								</div>
								<div class="kt-widget5__content">
									<div class="kt-widget5__stats">
										<span class="kt-widget5__number">{{product.deci | number : '1.0-2'}} <small>desi</small></span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="productStock$ | async as productStock" [ngClass]="(numberTabByUsers | async) == TAB2 ? 'tab-pane active': 'tab-pane'" [attr.id]="TAB2">
						<div class="kt-widget5">
							
							<div *ngFor="let stock of productStock$ | async" class="kt-widget5__item pb-0">
								<div class="kt-widget5__content">
									<div class="kt-widget5__pic">
										<i class="la la-map-pin la-2x"></i>
									</div>
									<div class="kt-widget5__section">
										<span class="kt-widget5__title">
											{{stock.warehouseName}}
										</span>
									</div>
								</div>
								<div class="kt-widget5__content">
									<div class="kt-widget5__stats">
										<span class="kt-widget5__number kt-font-success h4">{{stock.totalStock}}</span>
									</div>
								</div>
							</div>

							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</div>


